var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.moduleReady && _vm.commodityId !== null && _vm.detailLink !== '')?_c('product-details',{attrs:{"commodity-id":_vm.commodityId,"module-id":_vm.moduleId,"is-modal":_vm.isModal,"edit-mode":_vm.editMode,"detail-link":_vm.detailLink}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }